module.exports = __webpack_public_path__ + "img/visa-white.bacbb20e.svg";